export function objectSnakeCaseToCamelCase (object) {
  if (typeof object !== 'object' || Array.isArray(object) || object === null) return object;

  let json = {};

  let keyConverted;
  let value;

  Object.keys(object).forEach(function (key) {
    keyConverted = stringToCamelCase(key);
    value        = object[`${key}`];

    if (value === null || Array.isArray(value) || typeof value !== 'object') {
      json[`${keyConverted}`] = value;
    } else {
      json[`${keyConverted}`] = objectSnakeCaseToCamelCase(value);
    }
  });

  return json;
}

export function stringToCamelCase (string) {
  if (!string || !string.includes('_')) return string;

  string = stringToCapitalize(string);

  return string.replace(string[0], string[0].toLowerCase());
}

export function stringToCapitalize (string) {
  if (!string || !string.includes('_')) return string;

  return string.toLowerCase().trim().split(/[ _]/g)
  .map(word => word.replace(word[0], word[0].toString().toUpperCase())).join('');
}

function cleanRut (val) {
  return val.replace(/[^[0-9kK]/g, '');
}

export function validateRut(value) {
  const rut = value;

  if (rut.length < 2) return rut;

  return cleanRut(rut).slice(0, -1).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + '-' + cleanRut(rut).slice(-1);
}